import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 13",
  class: "jl2-custom-simple-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.668 2.23c.051.05.08.108.08.182h.006v7.771c0 .16-.132.291-.291.291H8.558v2.235c0 .16-.13.291-.29.291H.29A.292.292 0 0 1 0 12.71V2.816c0-.16.131-.291.29-.291h1.905V.29c0-.16.131-.291.291-.291h5.947l.034.023h.012c.028 0 .074.023.114.057l2.075 2.15ZM8.684 1.01v1.134h1.095L8.684 1.009ZM6.329 3.5v1.17h1.214L6.33 3.5Zm1.642 1.751H6.044a.292.292 0 0 1-.29-.29V3.107H.581v9.311h7.39V5.251ZM2.777.581v1.945h3.267c.074 0 .142.028.2.08L8.466 4.75a.298.298 0 0 1 .091.21v4.933h1.614V2.725H8.399a.292.292 0 0 1-.291-.29V.582H2.777ZM2 8v3h.592V9.833h.205c.567 0 .913-.378.913-.929 0-.55-.337-.904-.863-.904H2Zm1.118.896c0 .32-.14.386-.345.386H2.6v-.731h.214c.197 0 .304.115.304.345ZM3.775 11V8h.748c.699 0 1.052.477 1.052 1.43 0 .386 0 1.57-1.093 1.57h-.707Zm.69-.55c.313 0 .502-.173.502-1.012 0-.838-.246-.887-.501-.887h-.107v1.89h.099l.008.008ZM5.708 8v3h.592V9.726h.887v-.559H6.3v-.6h.945V8H5.707Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}